/* eslint-disable max-len */
import 'react';

const BookArrowRightSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <mask id="mask0_8069_9206" style={{'maskType': 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                <rect width="18" height="18" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_8069_9206)">
                <path d="M7.7041 6.22363L10.2961 8.7963L7.7041 11.7766" stroke="#11141A" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </svg>
    );
};

export default BookArrowRightSvg;
